<template>
  <div id="app">
    <component :is="layout">
      <router-view :key="$i18n.locale" />
    </component>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
    DefaultLayout: () => import("@/layouts/DefaultLayout.vue"),
  },
  computed: {
    layout() {
      return this.$route.meta.layout || "default-layout";
    },
  },
};
</script>
